import React, { createContext, useContext, useState, useEffect, useRef } from 'react';
import automobyApi, { setOnNavigate, setOnSessionCallback, setOnUnauthorizedCallback } from '../Api';
import { useNavigate } from 'react-router-dom';
import { useUpdateEffect } from '../hooks/useUpdateEffect'; 
import Automoby from "../assets/Logo/Automoby";
import ContainerLogo from "../assets/Logo/ContainerLogo";
import { baseFileURL } from '../Api';
import AIG from "../assets/Logo/AIG";
import { useUser } from '../hooks/useUser';
const AuthContext = createContext();

export const useAuth = () => {
    return useContext(AuthContext);
}
   
export const AuthProvider = ({ children }) => {

    const companies = [
        {company_id:"1", type:1, name: 'Automoby', svg: <Automoby />,  svgBig: <Automoby />},
        {company_id:"2", type:1, name: 'AIG', svg: <AIG /> ,  svgBig: <AIG />},
        {company_id:"3" ,type:2 , name: 'კონტეინერი', svg: <ContainerLogo /> ,  svgBig: <ContainerLogo />}
      ];
      
    const [isLoggedIn, setIsLoggedIn] = useState(() => {
        const savedState = localStorage.getItem('isLoggedIn');
        return savedState ? JSON.parse(savedState) : false;
    });

    const storedFunctionRef = useRef(null);

    const [selectedCompany, setSelectedCompany] = useState({company_id:"1", name: 'Automoby Logo', svg: <div/> });  

    const [session, setSession] = useState({isAdmin: false});

    const {userService} = useUser(-1);


    const navigate = useNavigate();

    const [pingIntervalId, setPingIntervalId] = useState(null);

   
    useEffect(() => {
        setOnUnauthorizedCallback(() => {
            setIsLoggedIn(false); 
        });

        setOnSessionCallback((token) => {
            configureSession(token)
        });

        setOnNavigate((nav) => {
            navigate(nav);
        });

        const refreshToken = localStorage.getItem('refreshToken');

         if (refreshToken) {
            configureSession(refreshToken)  
        } 

    }, []); 

    const configureSession = (token) => {
        const sess = parseJwt(token)
        var isAdmin = false
        var isContainer = false

        if (sess.role === "administrator") {
            isAdmin = true
        }

        const company = companies.find(company => company.company_id === sess.company_id );

        if (company  && (company.type === 2)){
            isContainer = true
        }  
        
        const newSes = { ...sess, isAdmin: isAdmin, isContainer: isContainer };
        setSession(newSes)
    }


    const setStoredFunctionRef = (newFunc) => {
         storedFunctionRef.current = newFunc;
    };
       
    useUpdateEffect(() => {
        localStorage.setItem('isLoggedIn', JSON.stringify(isLoggedIn));
    }, [isLoggedIn]);


    useUpdateEffect(() => {
        const company = companies.find(company => company.company_id === session.company_id );
        if (company ){
          setSelectedCompany(company) 
        } 
      }, [session]);
    
 

    const login = async (login, password) => {
        
            const requestData = {
                login: login,
                password: password
            };

            const response = await automobyApi.post(`/login`, requestData);
            const { accessToken, refreshToken } = response.data;

            configureSession(accessToken) 

            localStorage.setItem('accessToken', accessToken);
            localStorage.setItem('refreshToken', refreshToken);

            if (storedFunctionRef.current) {
                storedFunctionRef.current();
           }

            setIsLoggedIn(true);
            if (baseFileURL === 'https://i-logistics.net') {
                 navigate('/containers');   
            } else {
                  navigate('/finances');   
            }

            window.location.reload();
    };


    const forgotPassword = async (email) => {

        return new Promise((resolve, reject) => {
 
            const requestData = {
              email: email, 
            };
    
          automobyApi.post(`/forgot-password`, requestData)
            .then(response => {
              resolve(response.data);
            })
            .catch(error => {
              console.error(error);
              reject(error);
            });
        });
    
       

    };


 


    const loginVia = async (data) => {
         
        configureSession(data.accessToken) 

        localStorage.setItem('accessToken', data.accessToken);
        localStorage.setItem('refreshToken', data.refreshToken);

        if (storedFunctionRef.current) {
            storedFunctionRef.current();
       }

        setIsLoggedIn(true);
             if (baseFileURL === 'https://i-logistics.net') {
                 navigate('/containers');  
               // window.location.href = '/containers';
            } else {
                  navigate('/finances');  
               // window.location.href = '/finances';
            }

};

    function isRole(...rolesArray) { 
        return rolesArray.includes(session.role);
    }

    const refreshCompany = async (companyId) => {
        try { 

            const { data } = await automobyApi.post('/refresh/company', {
                refreshToken: localStorage.getItem('refreshToken'),
                company_id:  parseInt(companyId, 10)
              });
      
            const { accessToken, refreshToken } = data;

            configureSession(accessToken) 

            localStorage.setItem('accessToken', accessToken);
            localStorage.setItem('refreshToken', refreshToken);
           
            if (storedFunctionRef.current) {
                 storedFunctionRef.current();
            }


            setIsLoggedIn(true);
            navigate('/'); 
        } catch (error) {
            console.error(error);
        }
    };


    const startPingProcess = () => {
        const ping = () => {
             userService.ping() 
        };

         ping();

         const id = setInterval(ping, 5000);

         document.addEventListener('visibilitychange', function() {
            if (document.visibilityState === 'hidden' && pingIntervalId) {
                clearInterval(pingIntervalId);
            } else if (document.visibilityState === 'visible' && isLoggedIn) {
                startPingProcess();
            }
        });

        return id;  
    };


    const logout = () => {
        setIsLoggedIn(false);
        localStorage.removeItem('accessToken');
        localStorage.removeItem('refreshToken');
    };

    const value = {
        isLoggedIn,
        session,
        login,
        loginVia,
        forgotPassword,
        logout,
        refreshCompany,
        selectedCompany: selectedCompany,
        setSelectedCompany: setSelectedCompany,
        companies: companies,
        setStoredFunctionRef,
        isRole,
    };

    function parseJwt (token) {
        var base64Url = token.split('.')[1];
        var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
        var jsonPayload = decodeURIComponent(window.atob(base64).split('').map(function(c) {
            return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
        }).join(''));
    
        return JSON.parse(jsonPayload);
    }

    return (
        <AuthContext.Provider value={value}>
            {children}
        </AuthContext.Provider>
    );
}